import { Api } from '../api';
import { IListagemCanal, IDetalheCanal } from 'shared/types';
import { AxiosError } from 'axios';


const getAll = async (): Promise<IListagemCanal[] | Error> => {
  try {
    const { data } = await Api.get('canais');
   
    if (data) {
      return data;
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    const err = error as AxiosError;
    if (err.response) {
      if(err.response.status === 401){
        return new Error('status 401');  
      }
    }
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getByOrg = async (org: number): Promise<IListagemCanal[] | Error> => {
  try {
    const { data } = await Api.get(`/Orgs/${org}/canais`);
   
    if (data) {
      return data;
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    const err = error as AxiosError;
    if (err.response) {
      if(err.response.status === 401){
        return new Error('status 401');  
      }
    }
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (org: number, id: number): Promise<IDetalheCanal | Error> => {
  try {
    const { data } = await Api.get(`/Orgs/${org}/canais/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const create = async (org: number, dados: Omit<IDetalheCanal, 'idCanal'>): Promise<number | Error> => {
  try {
    const { data } = await Api.post<IDetalheCanal>(`/Orgs/${org}/canais/`, dados);

    if (data) {
      return Number(data.IdCanal);
    }

    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const updateById = async (org: number, id: number, dados: IDetalheCanal): Promise<void | Error> => {
  try {
    await Api.put(`/Orgs/${org}/canais/${id}`, dados);
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const deleteById = async (org: number, id: number): Promise<void | Error> => {
  try {
    await Api.delete(`/Orgs/${org}/canais/${id}`);
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};


export const CanaisService = {
  getAll,
  getByOrg,
  create,
  getById,
  updateById,
  deleteById,
};
